import { render } from "./SubjectSchedule.vue?vue&type=template&id=0545cc21&scoped=true"
import script from "./SubjectSchedule.js?vue&type=script&lang=js"
export * from "./SubjectSchedule.js?vue&type=script&lang=js"

import "./SubjectSchedule.vue?vue&type=style&index=0&id=0545cc21&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0545cc21"]])

export default __exports__